module.exports = __webpack_public_path__ + "static/mark_3-ce9c11d42ee6666a99445a51d2b3dcae.png";